<template>
  <v-dialog
    :value="value"
    @input="$emit('input', $event)"
    width="500"
    class="modal-not-supported"
    persistent
  >
    <v-card class="dark">
      <v-card-title class="headline">Upps, falscher Browser!</v-card-title>
      <v-card-text class="body-1">Es sieht so aus, als würdest du einen Browser benutzen, der unsere Inhalte nicht unterstützt.</v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn
          color="purple"
          @click="$emit('input', false)"
          class="px-3 mb-3 mr-3"
        >
          Alles klar
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  name: 'ModalNotSupported',
  props: { 
    value: {
      type: Boolean,
      default: false
    }
  },
  title: '',
  text: ''
}
</script>
